import { render, staticRenderFns } from "./AgendamentoHistorico.vue?vue&type=template&id=40c1966a"
import script from "./AgendamentoHistorico.vue?vue&type=script&lang=js"
export * from "./AgendamentoHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports